
import {defineComponent, PropType} from "vue";
import "../../style/components/searchMobile.scss";
import PlaceModal, {TopCities} from "@vmodals/PlaceModal.vue";
import MapModal from "@vmodals/MapModal.vue";
//@ts-ignore
import {isArrNullOrEmpty} from "@utils/ArrayUtils";
import {PublicValuation} from "../Types/PublicValuation";
import {mapActions, mapState} from "pinia";
//@ts-ignore
import {useSearch} from "@wkComposables/useSearch";
import {SearchPlaceType} from "../Types/SearchPlaceTypes";
import {Modals} from "../Types/Modals";
//@ts-ignore
import {CONTRACT} from "@customTypes/ContractEnum";
//@ts-ignore
import {useSearchBeanPlace} from "@wkComposables/useSearchBeanPlace";
//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";
import Place from "@wikicasa/common/model/Place";
import ListingTypologyMultiSelectModal from "@vmodals/ListingTypologyMultiSelectModal.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import ValuationTypologyModal from "@vmodals/ValuationTypologyModal.vue";
import {IResidentialTypologies} from "@customTypes/VariableTypes";
//@ts-ignore
import BaseSnackbar from "@vueEntry/BaseSnackbar.vue";
//@ts-ignore
import {useBaseSnackbar} from "@wkComposables/useBaseSnackbar";
import { useCommonVars } from "@wkComposables/useCommonVars";
import {isSafari} from "@utils/DeviceDetection";
//@ts-ignore
import {redirectToValuation} from "@wkWebSrc/js/valuation/valuationCookie"
import {useSearchBeanStore} from "@store/SearchBeanStore";
import {useModalStore} from "@store/ModalStore";

enum MACROTYPOLOGY {
    CASE = 1,
    IMMOBILI_COMMERCIALI,
    TERRENI
}

enum STATE {
    HOME = 1,
    PLACE = 2,
    MAP = 3,
    SEARCH
}

export default defineComponent({
    name: "SearchMobile",
    components: {
        ValuationTypologyModal,
        BaseButton,
        ListingTypologyMultiSelectModal,
        BaseSnackbar,
        PlaceModal,
        MapModal,
    },
    props: {
        topCityList: {
            type: Object as PropType<TopCities>,
        },
        typologyIdList: {
            type: Array as () => number[],
        },
        macrotypologyIdDefault: {
            type: Number
        },
        contractTypeDefault: {
            type: Number
        }
    },
    setup(){
        const { showBaseSnackbar, handleShowSnackbar, baseSnackbarProps} = useBaseSnackbar()
        const { options, wkLabels, baseURL, cdn } = useCommonVars()
        const { search } = useSearch()
        const {
            updateSearchBeanBySearchPlace,
            updateSearchBeanByMapPlace,
        } = useSearchBeanPlace()

        return {
            showBaseSnackbar, handleShowSnackbar, baseSnackbarProps,
            options, wkLabels, baseURL, cdn,
            //useSearch
            search,
            //useSearchBeanPlace
            updateSearchBeanBySearchPlace,
            updateSearchBeanByMapPlace,
        }
    },
    data() {
        return {
            labelSelectedMultiSelectionTypology: "",//"Case - Qualsiasi",
            typologyDefault: [] as number[],
            contractDefault: 1,
            macroTypologyDefault: 1,
            place: null as Nullable<Place>,
            hasPolygon: false,
            radius: 0,
            aroundMe: false,
            previouslyAroundMe: false,
            sellingIsActive: false,
            valuationTypologyId: 1,
            lastValuationTypologyId: 1,
            publicValuation: {
                realEstateValuation: {
                    address: ""
                },
                privateValuation: true,
                contactDesired: null,
                email: "",
                name: "",
                surname: "",
                phone: null
            } as PublicValuation,
            loading: false,
            labelSelectedValuationTypology: "",
        }
    },
    computed: {
        isDisabledBtn(): boolean {
            return this.sellingIsActive ? !this.valuationReady : !this.hasPlace;
        },
        Modals() {
            return Modals
        },
        mapAroundYouLabel(): string {
            return this.wkLabels[`mapAroundYou${this.radius}`];
        },
        currentPlaceName(): string {
            let name = this.place?.displayName || "";
            const {zoneIdList, localityIdList, districtIdList, districtId, zoneId} = this.searchBean;
            const isZoneIdListEmpty = isArrNullOrEmpty(zoneIdList);
            const isLocalityListEmpty = isArrNullOrEmpty(localityIdList);
            const areDistrictsEmpty = isArrNullOrEmpty(districtIdList)

            /* Case: whole municipality selected or city
            * ===> No zonesSelected, no districtsSelected, no localities selected
            * */
            if(isZoneIdListEmpty && !zoneId && isLocalityListEmpty && areDistrictsEmpty && !districtId && this.place?.cityID){
                return /\((\w+)\)/.test(this.searchBean.cityDisplayName) ? `${this.searchBean.cityDisplayName || ""}` :
                    `${this.searchBean.cityDisplayName || ""} (${this.place.provinceAcronym})`
            }

            if (isZoneIdListEmpty && isLocalityListEmpty && !name)
                return "";

            if (districtIdList?.length > 1 && (!zoneIdList?.length && !zoneId)) {
                name = this.searchBean.cityDisplayName || "";
                name += " - " + districtIdList?.length + " " + this.labels.zones
            } else if(districtIdList?.length === 1 && (!zoneIdList?.length && !zoneId))
            {
                name = this.searchBean.cityDisplayName || "";
                name += " - " + this.place?.districtName;
            }
            else if (districtIdList?.length >= 1 && (zoneIdList?.length > 1 || zoneId)) {
                const totalZones = (zoneIdList?.length || 1) + districtIdList?.length;
                name = this.searchBean.cityDisplayName || "";
                name += " - " + totalZones + " " + this.labels.zones
            } else if (zoneIdList && zoneIdList.length > 1) {
                name = this.searchBean.cityDisplayName || "";
                name += " - " + zoneIdList.length + " " + this.labels.zones
            } else if (localityIdList && localityIdList.length > 1) {
                name = this.searchBean.cityDisplayName || "";
                name += " - " + localityIdList.length + " " + this.labels.zones
            }

            return name;
        },
        closeOnYouURL(): string {
            return this.urlFromLabel("closeOnYou");
        },
        drawOnMapURL(): string {
            return this.urlFromLabel("drawOnMap");
        },
        searchByZoneURL(): string {
            return this.urlFromLabel("searchByZone");
        },
        valuationReady(): boolean {
            return !!this.valuationTypologyId && !!this.place?.address;
        },
        listingTypologies(): Array<any> {
            return this.getOptions("listingTypologies");
        },
        enumContract() {
            return CONTRACT;
        },
        icon() {
            return this.updateIcon()
        },
        showValuation(): boolean {
            return window["_showValuation"];
        },
        labels(): Record<string, string> {
            return this.wkLabels;
        },
        backdrop(): HTMLElement {
            return document.getElementById("modalBackdropForNewMobileHome") as HTMLElement;
        },
        isDisabled(): boolean {
            if (this.sellingIsActive) {
                return !this.valuationReady;
            }
            return !this.hasPlace;
        },
        ...mapState(useSearchBeanStore, ["searchBean", "hasPlace", "realEstateCounter"]),
        ...mapState(useModalStore, ["showModal"])
    },
    mounted() {
        this.labelSelectedMultiSelectionTypology = this.options.listingTypologies[0]?.labelSelected ?? "Case - Qualsiasi";
        this.labelSelectedValuationTypology = this.options.residentialTypologiesFiltered[0]?.label ?? "Appartamento";
        this.typologyDefault = this.typologyIdList
        this.contractDefault = this.contractTypeDefault
        this.macroTypologyDefault = this.macrotypologyIdDefault

        window.onpopstate = () => {
            const {showModal} = this;
            switch (showModal) {
                case Modals.noModal:
                    break;
                case Modals.mapModal: {
                    this.closeMapModal();
                    break;
                }
                case Modals.placeModal: {
                    this.closeModal();
                    break;
                }
                default: {
                    break;
                }
            }
        };

        if (isSafari()) {
            window.onpageshow = function (event) {
                if (event.persisted) {
                    this.loading = true;
                    this.loading = false;
                }
            };
        }

    },
    methods: {
        urlFromLabel(label: string) {
            if (!this.wkLabels[label])
                return "";

            return this.wkLabels[label].replaceAll(" ", "-").trim().toLowerCase();
        },
        openModal(modal: Modals): void {
            this.setShowModal(modal);
        },
        closeModal(): void {
            this.setShowModal(Modals.noModal);
            window.history.replaceState(STATE.HOME, "", this.baseURL);
        },
        openPlaceModal(): void {
            this.openModal(Modals.placeModal);
            window.history.pushState(STATE.PLACE, "", this.baseURL + "/#" + this.searchByZoneURL);
        },
        openMapModal(obj: any): void {
            this.aroundMe = obj.aroundMe;
            this.openModal(Modals.mapModal);

            (this.aroundMe) ? window.history.pushState(STATE.MAP, "", this.baseURL + "/#" + this.closeOnYouURL)
                : window.history.pushState(STATE.MAP, "", this.baseURL + "/#" + this.drawOnMapURL);

        },
        closeMapModal(): void {
            this.closeModal();
            if (!this.isDesktopMode) {
                this.openPlaceModal();
            }
        },
        getPlaceFromModal(obj: SearchPlaceType): void {
            this.closeModal();

            if (!obj.place)
                return;

            this.place = obj.place;
            this.updateSearchBeanBySearchPlace(obj, false);
        },
        getPlaceFromMapModal(obj: any): void {
            this.closeModal();
            this.previouslyAroundMe = this.aroundMe;
            this.aroundMe = obj.aroundMe;
            this.radius = obj.radius;

            this.updateSearchBeanByMapPlace({
                polygon: obj.polygon,
                polygonForDB: obj.polygonForDB
            });
        },
        setRadiusAroundMe(obj: any): void {
            this.radius = obj.radius;
            this.setSearchBeanByKey({key: "polygonFromMap", value: obj.polygon});
        },
        handleSearch(e: Event): void {
            //@ts-ignore
            if (!this.hasPlace)
                return;

            this.search();
        },
        updateIcon(): string {
            const customResidentialIcon = ["box", "palazzi", "immobili-residenziali-altro", "nuove-costruzioni", "stanze-camere"];

            if (this.sellingIsActive)
                return "case";
            if (this.searchBean.macroTypologyId === MACROTYPOLOGY.CASE && !customResidentialIcon.includes(this.searchBean.listingTypologyURL || ""))
                return "case";
            else if (this.searchBean.macroTypologyId === MACROTYPOLOGY.IMMOBILI_COMMERCIALI)
                return "locali-commerciali";
            else if (this.searchBean.macroTypologyId === MACROTYPOLOGY.TERRENI)
                return "terreni";
            else
                //@ts-ignore
                return this.searchBean.listingTypologyURL || "case";
        },
        updateContractType(contractType: CONTRACT): void {
            switch (contractType) {
                case
                    CONTRACT.SALE:
                    this.updateSearchBean({
                        sale: true,
                        rent: false,
                        contractType: CONTRACT.SALE,
                        auctionType: 0,

                    });
                    this.sellingIsActive = false;
                    break;
                case
                    CONTRACT.RENT:
                    this.updateSearchBean({
                        sale: false,
                        rent: true,
                        contractType: CONTRACT.RENT,
                        auctionType: 0,
                    });
                    this.sellingIsActive = false;
                    break;
                case
                    CONTRACT.AUCTION:
                    this.updateSearchBean({
                        sale: false,
                        rent: false,
                        contractType: CONTRACT.AUCTION,
                        auctionType: 1,

                    });
                    this.sellingIsActive = false;
                    break;
                case
                    CONTRACT.SELLING:
                    this.updateSearchBean({
                        sale: false,
                        rent: false,
                    });
                    this.sellingIsActive = true;
                    this.valuationTypologyId = this.lastValuationTypologyId;
                    break;
                default:
                    this.updateSearchBean({
                        sale: true,
                        rent: false,
                        contractType: CONTRACT.SALE
                    });
            }
            this.vibrate()
        },
        getOptions(key: string) {
            return window["_options"][key];
        },
        vibrate() {
            try {
                if (window.navigator) {
                    navigator.vibrate(50);
                }
            } catch {
                console.error("vibration not supported here");
            }
        },
        updateTypologyLabel(label: string): void {
            this.labelSelectedMultiSelectionTypology = label;
        },
        manageClick(): void {
            if (this.isDisabled) {
                this.handleShowSnackbar({
                    title: "Attenzione",
                    body: "Seleziona almeno un place",
                    type: "warning"
                });

                return;
            }


            this.loading = true;
            this.sellingIsActive
                ? redirectToValuation(this.place, this.valuationTypologyId, true)
                : this.handleSearch()
        },
        manageSelectedTypology(valuationTypology: IResidentialTypologies): void {
            this.lastValuationTypologyId = valuationTypology.id;
            this.valuationTypologyId = this.lastValuationTypologyId;
            this.labelSelectedValuationTypology = valuationTypology.label;
        },
        ...mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean", "updateRESBCounter"]),
        ...mapActions(useModalStore, ["setShowModal"]),
        /*        ...mapMutations(["setSearchBean", "setSearchBeanByKey", "updateSearchBean", "setShowModal"]),
        ...mapActions(["updateRESBCounter"])*/
    },
})
